import { useAppContext } from "hooks";

type SymbolType = "$" | "£";

export const useCurrencySymbol = (): SymbolType => {
  const context = useAppContext();
  return context.currencySymbol;
};
